import { Outlet } from "react-router-dom";
import RoleForm from "./RoleForm";
import { RoleList } from "./RoleList";

export const adminRolesRoutes = [
  {
    path: "roles",
    element: Outlet,
    children: [
      {
        path: "",
        element: RoleList,
      },
      {
        path: "add",
        element: RoleForm,
      },
      {
        path: "edit/:id",
        element: RoleForm,
      },
    ],
  },
];
